import styled from 'styled-components'
import { Modal } from 'antd'
import { blue } from '../../color'

export const PopupSignWrapper = styled(Modal)`
  .ant-modal-content {
    background-color: #EBF0F6;
    border-radius: 12px;
  }
  .ant-modal-body {
    padding: 0 16px 16px 16px;
  }
  .ant-modal-header {
    padding: 16px 20px;
    background-color: transparent;
    border-bottom: none;
  }
  .ant-modal-footer {
    border-top: none;
    padding: 0 16px 16px;
  }
`

export const HeaderPopupSign = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DocumentWrapper = styled.div`
  height: 75vh;
  overflow-y: auto;
  padding-bottom: 10px;
  position: relative;
  background-color: #fff;
  padding-top: 10px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;

  .react-pdf__Document {
    display: flex;
    justify-content: center;
  }

  .document-wrapper {
    position: relative;

    .spin-box {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 300px;
      position: absolute;
      top: 20%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`

export const DocumentController = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 20px;
  max-width: ${props => (props.maxWidth ? props.maxWidth + 'px' : '800px')};
  margin: 0 auto 10px;
`

export const ThumbnailsWrapper = styled.div`
  overflow-y: auto;
  height: 75vh;
  overflow-x: hidden;
  border-right: 3px solid #e4e4e4;

  .rpv-thumbnail-list {
    height: auto;
  }

  .rpv-thumbnail-item {
    height: 150px;
  }

  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .thumbnail-box {
    width: 145px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 5px;
    padding: 10px 10px 0 10px;
    cursor: pointer;
    transition: 0.3s;
    margin-bottom: 10px;

    &:hover {
      background-color: #ccc;
    }
  }

  .thumbnail-box-active {
    background-color: #ccc;
  }
`

export const SignatureBox = styled.div`
  margin-bottom: 15px;

  .card {
    box-shadow: ${props =>
      props.isSelected
        ? '0 1px 2px -2px rgb(0 0 0 / 16%), 0 3px 6px 0 rgb(0 0 0 / 12%), 0 5px 12px 4px rgb(0 0 0 / 9%)'
        : null};

    .ant-card-cover {
      background-color: #faf7f77a;
    }

    .img-box {
      height: 220px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 200px;
        width: 100%;
        object-fit: contain;
        max-width: 100%;
      }
    }

    .ant-card-body {
      border-top: 1px solid #eaeaea;
      padding: 15px 10px;
    }
  }
`
export const SignatureList = styled.div`
  height: calc(75vh - 200px);
  overflow-y: auto;
  padding: 0 5px;

  ::-webkit-scrollbar {
    width: 3px;
  }
`

export const NameDocument = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => (props.signed ? '#27ae60' : blue)};
  line-height: 30px;
  background-color: #d5e4ed;
  cursor: pointer;
  border-radius: 5px;
  text-decoration: ${props => props.signed && 'underline'};

  max-width: ${props => (props.maxWidth ? props.maxWidth + 'px' : '600px')};
  margin: 0 auto 10px;
  .ant-tag.ant-tag-green {
    border-radius: 12px;
  }
`
